import { createContext, useContext, ReactNode, useMemo } from 'react';
import { GridApiPro } from '@mui/x-data-grid-pro';

export interface ReportDragContextValue {
  groupId: string | undefined;
  gridApiReference: React.RefObject<GridApiPro | null>;
  isDragging?: boolean;
}

const ReportDragContext = createContext<ReportDragContextValue | undefined>(undefined);

export const ReportDragProvider = ({
  children,
  groupId,
  gridApiReference,
  isDragging,
}: {
  children: ReactNode;
  groupId: string | undefined;
  gridApiReference: React.RefObject<GridApiPro | null>;
  isDragging?: boolean;
}) => {
  const value = useMemo(() => ({ groupId, gridApiReference, isDragging }), [groupId, gridApiReference, isDragging]);

  return <ReportDragContext.Provider value={value}>{children}</ReportDragContext.Provider>;
};

export const useReportDrag = () => {
  const context = useContext(ReportDragContext);
  if (!context) {
    throw new Error('useReportDrag must be used within ReportDragProvider');
  }
  return context;
};
